// src/components/Layout.tsx
import { Link, Outlet } from "react-router-dom";
import useAuth from "../context/AuthContext"; // or "../hooks/useAuth" if you use that passthrough

export default function Layout() {
  const { user, isAuthenticated, logout } = useAuth();

  return (
    <div>
      <header
        style={{
          padding: "12px 20px",
          background: "var(--header-bg)",
          borderBottom: "1px solid var(--border)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <nav>
          <Link to="/clients" style={{ marginRight: 12 }}>
            Clients
          </Link>
          <Link to="/engagements">Engagements</Link>
        </nav>

        <div>
          {isAuthenticated ? (
            <>
              <span style={{ marginRight: 12, fontWeight: "bold" }}>
                {user?.name || user?.email || "User"}
              </span>
              <button
                onClick={() => logout()}
                style={{
                  padding: "6px 10px",
                  cursor: "pointer",
                }}
              >
                Logout
              </button>
            </>
          ) : (
            <Link to="/login">Login</Link>
          )}
        </div>
      </header>

      <main style={{ padding: 20 }}>
        {/* child routes will render here */}
        <Outlet />
      </main>
    </div>
  );
}
